module.exports = __webpack_public_path__ + "assetsclientes/img/card-basic-clock.8c9bdd3e.jpg";